import { faPause, faPlay } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState, useRef } from 'react';

function VideoPlayer({ src, style }) {
  const videoRef = useRef(null);
  const [currentTime, setCurrentTime] = useState(0);
  const [userSeeking, setUserSeeking] = useState(false);

  const handleTimeUpdate = () => {
    if (!userSeeking) {
      setCurrentTime(videoRef.current.currentTime);
    }
  };

  const handleSeeking = () => {
     setUserSeeking(true);
  };
  
  const handleSeeked = () => {
    setUserSeeking(false);
    if (videoRef.current.currentTime > currentTime) {
      videoRef.current.currentTime = currentTime;
    }
  };

  return (
    <div className='video-container'>
        <video
            ref={videoRef}
            src={src}
            controls={true}
            onTimeUpdate={handleTimeUpdate}
            onSeeking={handleSeeking}
            onSeeked={handleSeeked}
            controlsList='progressbar'
            style={style}
        />
        <button 
            className='ctrl-button'
            onClick={() => videoRef.current.play()}
        >
            play{"  "}
            <FontAwesomeIcon icon={faPlay} />
        </button>
        <button 
            className='ctrl-button'
            onClick={() => videoRef.current.pause()}
        >
            pause{"  "}
            <FontAwesomeIcon icon={faPause} />
        </button>
    </div>
  );
}
export default VideoPlayer;